<template>
  <div class="common-table-container-view">
    <vxe-table
      :border="border"
      width="100%"
      show-overflow
      :tooltip-config="{ contentMethod: showTooltipMethod, enterable: true }"
      :expand-config="expandConfig"
      :loading="loading"
      highlight-hover-row
      :highlight-current-row="highlightCurrentRow"
      align="left"
      :height="!autoTableHeight ? height : 'auto'"
      :max-height="tableMaxHeight"
      stripe
      column-key
      row-key
      :auto-resize="autoResize"
      :sort-config="{ trigger: 'cell', ...sortConfig }"
      :edit-config="{ trigger: 'manual', mode: 'row' }"
      :resizable="resizable"
      :row-class-name="rowClassName"
      @checkbox-all="selectAllEvent"
      @checkbox-change="selectChangeEvent"
      @cell-click="cellClick"
      @cell-dblclick="cellDblclick"
      :context-menu="contextMenu"
      @context-menu-click="menuClick"
      @scroll="tableScroll"
      @sort-change="sortChangeEvent"
      :header-cell-class-name="headerCellClassName"
      :cell-class-name="cellClassName"
      header-row-class-name="tableHeader"
      ref="xTable"
      :data="tableData"
      class="common-table-container ui-v2"
      :class="{'is-mutiSelect': mutiSelect}"
      row-id="id"
      v-bind="$attrs"
      v-on="$listeners"
      :checkbox-config="{
        labelField: '',
        checkMethod: checCheckboxkMethod,
        reserve: checkboxReserve,
        trigger: checkboxTrigger,
        range: checkboxRange,
        highlight: true,
        ...checkboxConfig,
      }"
    >
      <vxe-table-column
        type="checkbox"
        width="50"
        :fixed="checkboxFixed"
        align="left"
        v-if="mutiSelect"
      ></vxe-table-column>
      <vxe-table-column
        type="seq"
        align="center"
        :title="seqNumberTitle"
        :width="seqNumberTitleWidth"
        v-if="seqNumber"
      ></vxe-table-column>
      <vxe-table-column v-if="expandShow" type="expand" :width="expandWidth">
        <template #content="{ row }">
          <slot name="expand" :item="row"></slot>
        </template>
      </vxe-table-column>
      <!--columnSetting 列表显示 
        header-class-name 给表头的单元格附加 className
      --->
      <template v-for="(column, index) in columns">
        <vxe-table-column
          :title="column.caption"
          :key="index"
          :field="column.fieldName"
          :width="column.width"
          v-if="!column.hidden"
          :fixed="column.fixed"
          :align="column.textAlignment"
          :sortable="column.allowSort"
          :minWidth="column.minWidth"
          :params="column.params"
          :header-class-name="column.cellClass"
          :class-name="column.className"
          show-overflow
        >
          <template v-if="column.slotHeader" #header>
            <slot :name="column.fieldName + '-header'" :column="column"></slot>
          </template>
          <template slot-scope="{ row }">
            <!-- render column -->
            <template v-if="column.render">
              <span>{{ column.render(row, column) }}</span>
            </template>
            <!-- formatter column -->
            <template v-else-if="column.formatter">
              <span
                @click.stop="
                  formatterColumnClick(column.fieldName, row, $event)
                "
                @mouseover.stop="
                  formatterColumnMouseOver(column.fieldName, row, $event)
                "
                @mouseleave.stop="
                  formatterColumnMouseLeave(column.fieldName, row, $event)
                "
              >
                <span v-html="column.formatter(row, column)"></span>
              </span>
            </template>
            <!-- hoverCard column -->
            <template v-else-if="column.hoverCard">
              <common-ellipsis-tooltip
                class="item"
                effect="dark"
                v-if="
                  column.iconShowrender &&
                  column.iconShowrender(row) &&
                  !column.hoverCardIconCustom
                "
                :content="
                  (row[column.fieldName] &&
                    row[column.fieldName] !== 'null' &&
                    row[column.fieldName] !== 'undefined') ||
                  row[column.fieldName] == '0'
                    ? row[column.fieldName]
                    : '--'
                "
                placement="top"
              >
                <p class="ver-a-m">
                  {{
                    (row[column.fieldName] &&
                      row[column.fieldName] !== "null" &&
                      row[column.fieldName] !== "undefined") ||
                    row[column.fieldName] == "0"
                      ? row[column.fieldName]
                      : "--"
                  }}
                </p>
              </common-ellipsis-tooltip>
              <span class="ver-a-m" v-else>
                {{
                  (row[column.fieldName] &&
                    row[column.fieldName] !== "null" &&
                    row[column.fieldName] !== "undefined") ||
                  row[column.fieldName] == "0"
                    ? row[column.fieldName]
                    : "--"
                }}
              </span>
              <el-tooltip
                popper-class="table-hover-card-tooltip-container"
                class="item"
                effect="dark"
                :content="
                  (row[column.hoverFieldName] &&
                  column.hoverOriginTextRender &&
                  column.hoverOriginTextRender(row)
                    ? (column.hoverOriginText
                        ? column.hoverOriginText + ':  '
                        : '') + row[column.hoverFieldName]
                    : '' + row[column.hoverFieldName]) || '--'
                "
                placement="top"
              >
                <span class="card-icon-container ver-a-m">
                  <svg-icon
                    :name="column.cardIcon"
                    class="ml6 ver-a-m cardIcon"
                    v-if="
                      column.iconShowrender &&
                      column.iconShowrender(row) &&
                      !column.hoverCardIconCustom
                    "
                    :style="{ fontSize: column.hoverCardIconFontSize ? column.hoverCardIconFontSize : '16px'}"
                  />
                  <span
                    v-html="
                      column.hoverCardIconFormatter &&
                      column.hoverCardIconFormatter(row, column)
                    "
                    v-else
                  ></span>
                </span>
              </el-tooltip>
            </template>
            <!-- status column -->
            <template v-else-if="column.type === 'status'">
              <status-item :status="row[column.fieldName]"></status-item>
            </template>
            <!-- Stops column -->
            <template v-else-if="column.type === 'stops'">
              <span class="stops-item-container" @click.stop="stopsRow(row)">{{
                row[column.fieldName]
              }}</span>
            </template>
            <!-- singleColumnClick column -->
            <template v-else-if="column.type === 'singleColumnClick'">
              <span
                class="single-column-click"
                @click.stop="singleColumnClick(column.fieldName, row)"
                >{{
                  row[column.fieldName] && row[column.fieldName] !== "null"
                    ? row[column.fieldName]
                    : "--"
                }}</span
              >
            </template>
            <!-- Driver column -->
            <template v-else-if="column.type === 'img-name'">
              <driver-item
                :driver="row[column.fieldName]"
                @driverItem="driverItem"
                @driverItem2="driverItem2"
                @imgPreView="imgPreView"
                @pdfPreView="pdfPreView"
              ></driver-item>
            </template>
            <!-- Doc column -->
            <template v-else-if="column.type === 'doc'">
              <div class="doc-item-container" @click.stop="docRow(row)">
                <img src="../images/documents.svg" alt="" />
                <span class="">{{ row[column.fieldName] }}</span>
              </div>
            </template>
            <!-- slot -->
            <template v-else-if="column.type === 'slot'">
              <slot :name="column.fieldName" :item="row"></slot>
            </template>
            <!-- normal column -->
            <template v-else-if="column.type === 'team'">
              <div class="team-container">
                <div class="first">
                  <common-ellipsis-tooltip
                    effect="dark"
                    :content="row.primaryDriverName"
                    placement="top"
                  ></common-ellipsis-tooltip>
                </div>
                <div class="second">
                  <common-ellipsis-tooltip
                    effect="dark"
                    :content="row.secondlyDriverName"
                    placement="top"
                  ></common-ellipsis-tooltip>
                </div>
                <el-tooltip
                  popper-class="team-hover-card-tooltip-container"
                  class="item"
                  effect="dark"
                  :content="column.tooltipsTextrender?column.tooltipsTextrender(row):'This item is created by carriers'"
                  placement="top"
                  :disabled="!(column.iconShowrender &&
                        column.iconShowrender(row))"
                  >
                    <svg-icon
                      :name="column.icon || 'driverSeats'"
                      class="ml6 ver-a-m cardIcon"
                      v-if="
                        column.iconShowrender &&
                        column.iconShowrender(row)
                      "
                      :style="{ fontSize: column.iconFontSize ? column.iconFontSize : '16px'}"
                    />
                </el-tooltip>
              </div>
            </template>
            <!-- normal column -->
            <template v-else>
              <span>{{
                (row[column.fieldName] &&
                  row[column.fieldName] !== "null" &&
                  row[column.fieldName] !== "null null" &&
                  row[column.fieldName] !== "undefined") ||
                row[column.fieldName] == "0"
                  ? row[column.fieldName]
                  : "--"
              }}</span>
            </template>
          </template>
        </vxe-table-column>
      </template>
      <!--region Action-->
      <vxe-table-column
        :title="actionTitle"
        align="right"
        :fixed="actionFixed"
        :width="actionWidth"
        v-if="showActionColumn"
      >
        <template slot-scope="{ row, $rowIndex }">
          <span v-if="moreBtnShow">
            <el-tooltip :class="['item', row.commandDisabled ? 'cursor-disabled' : '']" effect="dark" content="No Permission" placement="top" :disabled="!row.noPermission">
              <el-dropdown
                @command="
                  (command) => {
                    onDropdownCommand(command, row);
                  }
                "
                :trigger="triggerOption"
                ref="actionDropdownRefs"
                style="height: 100%; width: 100%"
              >
                <span
                  @click.stop="actionClick(row, $event, $rowIndex)"
                  :class="
                    row.commandDisabled
                      ? 'transparentB transparent-disabled'
                      : 'transparentB'
                  "
                >
                  
                    <span
                      :class="
                        row.commandDisabled
                          ? 'el-dropdown-disabled-link el-dropdown-link-item'
                          : $rowIndex === activeActionIndex
                          ? 'el-dropdown-active-link el-dropdown-link-item'
                          : 'el-dropdown-link el-dropdown-link-item'
                      "
                    ></span>
                  
                </span>
                <slot name="actionList" :row="row">
                  <el-dropdown-menu
                    slot="dropdown"
                    class="action-dropdown-menu-container"
                    :disabled="row.commandDisabled"
                  >
                    <template v-for="(action, index) in actionList">
                      <template v-if="action.fontColor === 'red'">
                        <el-tooltip 
                          class="item" 
                          effect="dark" 
                          :content="(action.noPermissionRenderText && action.noPermissionRenderText()) ? action.noPermissionRenderText() : 'No Permission'" placement="left" :key="action.command + index" :disabled="!(action.noPermissionRender && action.noPermissionRender(row))">
                          <span>
                            <el-dropdown-item
                              v-if="
                                action.showCommandRender &&
                                  action.showCommandRender(row)
                              "
                              :disabled="
                                action.disabledRender && action.disabledRender(row)
                              "
                              :command="action.command"
                              :key="action.command + index"
                              class="delete-action-container"
                            >
                              <svg-icon
                                v-if="action.icon"
                                :name="action.icon"
                                :key="action.command + index"
                                :style="{
                                  fontSize: '20px',
                                  marginRight: '6px',
                                  verticalAlign: 'middle',
                                  color:
                                    action.disabledRender &&
                                    action.disabledRender(row)
                                      ? '#DADCE1'
                                      : '',
                                }"
                              />
                              <span style="vertical-align: middle">{{
                                action.command
                              }}</span>
                            </el-dropdown-item>
                        </span>
                        </el-tooltip>
                      </template>
                      <template v-else>
                        <el-tooltip class="item" effect="dark" content="No Permission" placement="left" :key="action.command + index" :disabled="!(action.noPermissionRender && action.noPermissionRender(row))">
                          <span>
                            <el-dropdown-item
                              v-if="
                                action.showCommandRender &&
                                  action.showCommandRender(row)
                              "
                              :disabled="
                                action.disabledRender && action.disabledRender(row)
                              "
                              :key="action.command + index"
                              :command="action.command"
                            >
                              <svg-icon
                                v-if="action.icon"
                                :name="action.icon"
                                :key="action.command + index"
                                :style="{
                                  fontSize: '20px',
                                  marginRight: '6px',
                                  verticalAlign: 'middle',
                                  color:
                                    action.disabledRender &&
                                    action.disabledRender(row)
                                      ? '#DADCE1'
                                      : '',
                                }"
                              /><span style="vertical-align: middle">{{
                                action.command
                              }}</span>
                            </el-dropdown-item>
                          </span>
                        </el-tooltip>
                      </template>
                    </template>
                  </el-dropdown-menu>
                </slot>
              </el-dropdown>
            </el-tooltip>
          </span>
          <span v-else class="cursor-p normal-action-container">
           
              <span
                v-for="action in actionList"
                :key="action.id"
                @click.stop="normalActionBtnClick(action, row)"
                :class="['cursor-p', action.id === 'Delete' ? 'delete-icon' : '', action.disabled && action.disabled() ? 'is-disabled' : '']"
                :style="{
                  color:
                    row.colorInfo && row.colorInfo.id === action.id
                      ? row.colorInfo.color
                      : '',
                }"
              > 
                <el-tooltip class="item" effect="dark" content="No Permission" placement="top" :disabled="!(action.noPermissionRender && action.noPermissionRender(row))">
                  <svg-icon :name="action.icon" :style="{ fontSize: '16px' }" />
                  {{ action.name }}
                </el-tooltip>
              </span>
          </span>
        </template>
      </vxe-table-column>
      <!--endregion-->
      <!-- empty show -->
      <div slot="empty" class="empty-container">
        <template v-if="!showPromotionPage">
          <template v-if="!customEmpty">
            <p style="display: flex;justify-content: center;">
              <img src="../images/no-results-empty-state.svg" />
            </p>
            <p style="margin-top:12px;">
              <span>{{ newEmptyText }}</span>
            </p>
          </template>
          <slot v-if="customEmpty" name="customEmpty"></slot>
        </template>
      </div>
      <!--endregion-->
    </vxe-table>
    <PromotionPage
      v-if="showPromotionPage"
      :type="promotionPageType"
      :mainBtnLoading="promotionPageMainBtnLoading"
      @mainBtnclick="promotionPageMainBtnclick"
      @subBtnclick="promotionPageSubBtnclick"
      @promotionPpageOnDropdownCommand="promotionPpageOnDropdownCommand"
    >
    </PromotionPage>
  </div>
</template>
<script>
import StatusItem from "./components/status-item";
import DriverItem from "./components/driver-item";
import Sortable from "sortablejs";
import PromotionPage from "./components/promotion-page";
export default {
  data() {
    return {
      commonIconStyle: "commonIconStyle",
      malr5: "malr5",
      activeActionIndex: null,
    };
  },
  components: { StatusItem, DriverItem, PromotionPage },
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      },
    },
    contextMenu: {
      type: [Object, Function],
      default: function() {
        return {
          // header: {
          //   disabled: false,
          //   options: [
          //     [
          //       {
          //         code: "RESET_RESIZABLE",
          //         name: "重置列宽",
          //       },
          //       {
          //         code: "SORT_ASC",
          //         name: "升序",
          //       },
          //       {
          //         code: "SORT_DESC",
          //         name: "降序",
          //       },
          //       {
          //         code: "FIXED_LEFT_COLUMN",
          //         name: "固定左侧",
          //       },
          //       {
          //         code: "FIXED_RIGHT_COLUMN",
          //         name: "固定右侧",
          //       },
          //       {
          //         code: "CLEAR_FIXED_COLUMN",
          //         name: "清除固定列",
          //       },
          //       {
          //         code: "HIDDEN_COLUMN",
          //         name: "隐藏当前列",
          //       },
          //       {
          //         code: "RESET_COLUMN",
          //         name: "重置列的可视状态",
          //       },
          //       {
          //         code: "test",
          //         name: "自定义",
          //       },
          //     ],
          //   ],
          // },
        };
      },
    },
    columns: {
      type: Array,
      default: () => [],
    },
    operates: {
      type: Object,
      default: function() {
        return {};
      },
    },
    emptyText: {
      type: String,
      default: "You do not have any load yet",
    },
    newEmptyText: {
      type: String,
      default:
        "No results matched this search. Please try a different search criteria.",
    },
    checkboxFixed: {
      type: String,
      default: "left",
    },
    actionFixed: {
      type: String,
      default: "right",
    },
    triggerOption: {
      type: String,
      default: "click",
    },
    actionWidth: {
      type: String,
      default: "91px",
    },
    rowClassName: {
      type: [String, Function],
    },
    actionList: {
      //action数据
      type: Array,
      default: () => [
        {
          command: "Edit",
          showCommandRender: () => {
            return true;
          },
        },
        {
          command: "Delete",
          showCommandRender: () => {
            return true;
          },
          fontColor: "red",
        },
      ],
    },
    showActionColumn: {
      type: Boolean,
      default: true,
    },
    moreBtnShow: {
      type: Boolean,
      default: true,
    },
    normalActionBtnShow: {
      type: Boolean,
      default: false,
    },
    seqNumberTitle: {
      type: String,
      default: "序号",
    },
    seqNumberTitleWidth: {
      type: String,
      default: "50",
    },
    operateTitle: {
      type: String,
      default: "操作",
    },
    autoTableHeight: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: "800px",
    },
    mutiSelect: {
      type: Boolean,
      default: false,
    }, // 是否显示复选框
    loading: {
      type: Boolean,
      default: false,
    },
    dropcolumn: {
      type: Boolean,
      default: false,
    },
    resizable: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
    isArchivesManagent: {
      type: Boolean,
      default: false,
    },
    seqNumber: {
      type: Boolean,
      default: false,
    }, // 是否显示序号
    operatesShow: {
      type: Boolean,
      default: false,
    }, // 是否显示操作列
    autoResize: {
      type: Boolean,
      default: false,
    },
    backListDetailWinShowIcon: {
      type: Boolean,
      default: false,
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true,
    },
    sortConfig: {
      type: Object,
      default: () => {},
    },
    customEmpty: {
      type: Boolean,
      default: false,
    },
    tableMaxHeight: {
      type: String,
      default: "",
    },
    checkboxReserve: {
      //是否保留勾选状态，对于某些场景可能会用到，比如数据被刷新之后还保留之前选中的状态（需要有 row-id）
      type: Boolean,
      default: false,
    },
    checkboxRange: {
      //开启复选框范围选择功能（启用后通过鼠标在复选框的列内滑动选中或取消指定行）
      type: Boolean,
      default: false,
    },
    checkboxTrigger: {
      // 触发方式: default（默认）, cell（点击单元格触发）, row（点击行触发）
      type: String,
      default: "",
    },
    // 展开行配置
    expandShow: {
      type: Boolean,
      default: false,
    },
    expandWidth: {
      type: String,
      default: "",
    },
    expandConfig: {
      type: Object,
      default: () => ({}),
    },
    showPromotionPage: {
      // showPromotionPage
      type: Boolean,
      default: false,
    },
    promotionPageType: {
      type: String,
      default: "",
    },
    promotionPageMainBtnLoading: {
      // promotionPageMainBtnLoading
      type: Boolean,
      default: false,
    },
    actionTitle: {
      type: String,
      default: "Actions",
    },
    checkboxConfig: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    //全选事件
    selectAllEvent({ checked, records }) {
      this.$emit("selection-change", records, checked, "all");
    },
    // 单选事件
    selectChangeEvent({ checked, records, $event, cell }) {
      $event.cancelBubble = true;
      this.$emit("selection-change", records, checked, "single");
      if (checked) {
        cell.classList.add('is-checkbox')
      } else {
        let parentNode = $event.target.parentNode
        while(!parentNode.classList.contains('is-checkbox')) {
          parentNode = parentNode.parentNode
        }
        parentNode.classList.remove('is-checkbox')
      }
    },
    // 列表单击事件
    cellClick({ row, rowIndex, $rowIndex, column }) {
      if (column?.params?.noClickCell) return; // noClickCell 不触发点击事件
      this.$emit("clickRow", row, rowIndex, $rowIndex, column);
    },
    // 列表双击事件
    cellDblclick({ row, rowIndex, $rowIndex }) {
      this.$emit("dbClickRow", row, rowIndex, $rowIndex);
    },
    // 功能菜单点击
    menuClick(metadata, event) {
      console.log(metadata.menu, event);
      if (metadata.menu.code == "test") {
        console.log(metadata.menu.name);
      }
    },
    // 可编辑表格保存
    saveRowEvent(row, rowIndex) {
      let self = this;
      self.$refs.xTable.clearActived().then(() => {
        self.$emit("saveRowEvent", row, rowIndex);
      });
    },
    // Edit
    editTable(row) {
      console.log("editTable" + JSON.stringify(row));
      this.$emit("editTable", row);
    },
    // Del
    delTable(row) {
      console.log("delTable" + JSON.stringify(row));
      this.$emit("delTable", row);
    },
    // stopsRow
    stopsRow(row) {
      console.log("stopsRow" + JSON.stringify(row));
      this.$emit("stopsRow", row);
    },
    // docRow
    docRow(row) {
      console.log("docRow" + JSON.stringify(row));
      this.$emit("docRow", row);
    },
    // onDropdownCommand
    onDropdownCommand(command, row) {
      // console.log(command, row);
      // activeActionIndex change
      this.activeActionIndex = null;
      this.$emit("onDropdownCommand", command, row);
    },
    driverItem(item) {
      console.log(item);
      this.$emit("driverItem", item);
    },
    driverItem2(item) {
      console.log(item);
      this.$emit("driverItem2", item);
    },
    imgPreView(item) {
      console.log(item);
      this.$emit("imgPreView", item);
    },
    pdfPreView(item) {
      console.log(item);
      // window.open(item.avatar);
      this.$emit("pdfPreView", item);
    },
    singleColumnClick(fieldName, item) {
      console.log(fieldName, item);
      this.$emit("singleColumnClick", fieldName, item);
    },
    formatterColumnClick(fieldName, item, $event) {
      // console.log(fieldName, item, $event);
      this.$emit("formatterColumnClick", fieldName, item, $event);
    },
    formatterColumnMouseOver(fieldName, item, $event) {
      // console.log(fieldName, item, $event);
      this.$emit("formatterColumnMouseOver", fieldName, item, $event);
    },
    formatterColumnMouseLeave(fieldName, item, $event) {
      // console.log(fieldName, item, $event);
      this.$emit("formatterColumnMouseLeave", fieldName, item, $event);
    },
    // 重写默认的提示内容
    showTooltipMethod() {},
    // showTooltipMethod({ type, column, row, items, _columnIndex }) {
    //   console.log(type, column, row, items, _columnIndex);
    //   // 重写默认的提示内容
    // },
    headerCellClassName({ column }) {
      if (column.type === "checkbox" || column.title === "Actions") {
        return "no-dropcolumn";
      }
    },
    cellClassName({ column }) {
      if (column?.params?.noClickCell) {
        return "no-click-cell";
      }
      if (column?.params?.stops) {
        return "stops-cell-container";
      }
      if (column.title === "Actions") {
        return "action-cell-container";
      }
      return "click-cell";
    },
    actionClick(row, activeDom, index) {
      // console.log(row, activeDom);
      let activeDomChildrenList = [
        ...activeDom.currentTarget.parentNode.parentNode.parentNode.parentNode
          .parentNode.parentNode.children,
      ];
      let currentactiveDom =
        activeDom.currentTarget.parentNode.parentNode.parentNode.parentNode
          .parentNode;
      // row row--current change
      activeDomChildrenList.forEach((element) => {
        element.classList.remove("row--current");
      });
      currentactiveDom.classList.add("row--current");
      // action actionActive change
      this.activeActionIndex = this.activeActionIndex === index ? null : index;
      // for (let item of this.tableData) {
      //   this.$set(item, "actionActive", false);
      // }
      // this.$set(row, "actionActive", true);
    },
    normalActionBtnClick(action, row) {
      // console.log(type, row);
      if (action.disabled && action.disabled()) return null
      this.$emit("normalActionBtnClick", action.id, row);
    },
    initBackground($event) {
      // console.log("initBackground", $event);
      if (
        $event.target.className === "vxe-cell c--tooltip" ||
        $event.target.parentNode.className === "vxe-cell c--tooltip"
      )
        return;
      let activeCellList = document.querySelectorAll(".vxe-body--row");
      // for (let item of this.tableData) {
      //   this.$set(item, "actionActive", false);
      // }
      let activeLink = document.querySelectorAll(".vxe-body--row .el-dropdown-active-link");
      activeLink.forEach((element) => {
        if (element.classList.contains("el-dropdown-active-link")) {
          element.classList.remove("el-dropdown-active-link");
          element.classList.add("el-dropdown-link");
        }
      });
      this.activeActionIndex = null;
      activeCellList.forEach((element) => {
        if (element.classList.contains("row--current")) {
          element.classList.remove("row--current");
        }
      });
    },
    tableScroll({ scrollLeft, isX }) {
      // console.log(type, scrollTop, scrollLeft, isX, isY, $event);
      if (isX) {
        let scrollBox = document.getElementById("scrollBox");
        scrollBox.scrollLeft = scrollLeft;
      }
      let actionDropdownMenuList = document.querySelectorAll(
        ".action-dropdown-menu-container"
      );
      actionDropdownMenuList.forEach((item) => {
        item.style = "display:none";
      });
    },
    // checCheckboxkMethod
    checCheckboxkMethod({ row }) {
      if (row.checCheckboxkRenderObj?.checCheckboxkRender) {
        return row[row.checCheckboxkRenderObj?.checCheckboxkRenderFileName]
          ? true
          : false;
      } else {
        return true;
      }
    },
    columnDrop() {
      this.$nextTick(() => {
        const $table = this.$refs.xTable;
        this.sortable = Sortable.create(
          $table.$el.querySelector(
            ".body--wrapper>.vxe-table--header .vxe-header--row"
          ),
          {
            handle: ".vxe-header--column:not(.no-dropcolumn)",
            onEnd: ({ item, newIndex, oldIndex }) => {
              const { fullColumn, tableColumn } = $table.getTableColumn();
              const targetThElem = item;
              const wrapperElem = targetThElem.parentNode;
              const newColumn = fullColumn[newIndex];
              if (
                newColumn.type === "checkbox" ||
                newColumn.title === "Actions"
              ) {
                // 错误的移动
                if (newIndex > oldIndex) {
                  wrapperElem.insertBefore(
                    targetThElem,
                    wrapperElem.children[oldIndex]
                  );
                } else {
                  wrapperElem.insertBefore(
                    wrapperElem.children[oldIndex],
                    targetThElem
                  );
                }
                this.$message.warning({
                  message: "this column do not allow dragging.",
                });
                return;
              }
              // 转换真实索引
              const oldColumnIndex = $table.getColumnIndex(
                tableColumn[oldIndex]
              );
              const newColumnIndex = $table.getColumnIndex(
                tableColumn[newIndex]
              );
              // 移动到目标列
              const currRow = fullColumn.splice(oldColumnIndex, 1)[0];
              fullColumn.splice(newColumnIndex, 0, currRow);
              $table.loadColumn(fullColumn);
            },
          }
        );
      });
    },
    // 排序事件
    sortChangeEvent(info) {
      this.$emit("sortChangeEvent", info);
    },
    // promotionPageMainBtnclick
    promotionPageMainBtnclick(item) {
      // console.log('promotionPageMainBtnclick', item)
      this.$emit("promotionPageMainBtnclick", item);
    },
    // promotionPageSubBtnclick
    promotionPageSubBtnclick(item) {
      // console.log('promotionPageSubBtnclick', item)
      this.$emit("promotionPageSubBtnclick", item);
    },
    // promotionPpageOnDropdownCommand
    promotionPpageOnDropdownCommand(item) {
      this.$emit("promotionPpageOnDropdownCommand", item);
    },
    dropdownVisibleChange(visible, rowIndex, row) {
      this.$emit("visibleChange", visible, rowIndex, row);
    },
  },
  created() {
    if (this.dropcolumn) this.columnDrop();
  },
  mounted() {
    this.globalClick(this.initBackground);
    // 删除排序图标悬停显示的文案
    this.$nextTick(() => {
      let list =
        this.$refs.xTable.$el.querySelectorAll(".vxe-cell--sort i") || [];
      for (let i = 0; i < list.length; i++) {
        list[i].setAttribute("title", "");
      }
    });
  },
  beforeDestroy() {
    this.activeActionIndex = null;
    if (this.sortable) {
      this.sortable.destroy();
    }
    try {
      document
        .querySelector(".vxe-table--tooltip-wrapper")
        .classList.remove("is--visible");
    } catch {
      //  eslint-disable-next-line
    }
  },
  activated() {
    this.globalClick(this.initBackground);
  },
  deactivated() {
    this.activeActionIndex = null;
    if (this.sortable) {
      this.sortable.destroy();
    }
    
    try {
      let vxeTableTooltipWrapper = document
        .querySelectorAll(".vxe-table--tooltip-wrapper");
      console.log('vxeTableTooltipWrapper11',vxeTableTooltipWrapper);
      vxeTableTooltipWrapper.forEach((item) =>  {
        item.classList.remove("is--visible");
        item.style.top = "-1000px";
      })
    } catch {
      //  eslint-disable-next-line
    }
  },
};
</script>
<style lang="scss" scoped>
 .body{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 0px 16px;

    width: 300px;
    height: 290px;
    background: #FFFFFF;
    border-radius: 8px;
    .head {
        width: 266px;
        height: 16px;
    
        /* SemiBold/12 */
    
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        /* identical to box height, or 133% */
    
    
        /* Neutral Color/#000000 */
    
        color: #000000;
      }
    
      .text {
        width: 266px;
        height: 16px;
    
        /* Regular/12 */
    
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        /* identical to box height, or 133% */
    
    
        /* Neutral Color/#7F8596 */
    
        color: #7F8596;
      }
    }
.common-table-container-view {
  position: relative;
  &::before {
    background-color: transparent;
  }
  overflow: visible !important;
  // height: 100%;
  .header-status-text {
    padding-right: 20px;
    position: relative;
    cursor: pointer;
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: 0;
      margin-top: -8px;
      width: 16px;
      height: 16px;
      background: url("~@/assets/img/share-icon/ic-nor-filter.svg") no-repeat;
      background-size: 100% 100%;
    }
    &:hover {
      &::after {
        background-image: url("~@/assets/img/share-icon/ic-sel-filter.svg");
      }
    }
    &.is-active {
      &::after {
        background-image: url("~@/assets/img/share-icon/ic-sel-filter.svg");
      }
    }
  }
  .status-dropdown-container {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 20;
    top: 100%;
    padding: 6px 0;
    border-radius: 2px;
    box-shadow: 0 1px 5px 0 rgba(70, 83, 106, 0.2);
    background-color: #ffffff;
    .status-dropdown-item {
      padding-left: 16px;
      height: 38px;
      line-height: 38px;
      font-weight: normal;
      font-weight: 500;
      font-weight: 500;
      font-size: 14px;
      color: #001b42;
      cursor: pointer;
      &.is-active {
        color: #4066d4;
      }
      &:hover {
        background-color: #f0f2f5;
      }
    }
  }
  .common-table-email {
    font-weight: 500;
    font-size: 16px;
    line-height: normal;
    color: #001b42;
    font-weight: 500;
  }
  .common-table-text {
    font-weight: 500;
    font-size: 16px;
    line-height: normal;
    color: #001b42;
    font-weight: 500;
  }
  .status-tag {
    display: inline-block;
    padding: 5px 10px;
    line-height: normal;
    font-weight: 500;
    font-size: 14px;
    border-radius: 2px;
    font-weight: 500;
  }
  .pending-tag {
    background-color: #fef3e7;
    color: #f47b0c;
  }
  .active-tag {
    background-color: #eafaf4;
    color: #24ab86;
  }
  .common-action-btn {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .edit-action-btn {
  }
  .del-action-btn {
  }
  ::v-deep {

    .vxe-cell {
      padding: 0px;
      align-items: center;
    }
    .vxe-table--header{
      .vxe-cell{
        display: flex;
      }
      .col--right .vxe-cell {
        justify-content: flex-end;
      }
    }
    .vxe-table--body {
      // position: absolute;
      // width: 100% !important;
    }
    .vxe-table--body-wrapper,
    #scrollBox {
      &::-webkit-scrollbar {
        display: block;
        width: 8px;
        height: 8px;
        // background-color: #f5f5f5;
      }
      &::-webkit-scrollbar-track {
        // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 2px;
        // background-color: #f5f5f5;
      }
      &::-webkit-scrollbar-thumb {
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.3);
        &:hover {
          background-color: rgba(0, 0, 0, 0.5);
        }
      }
    }
    .vxe-table--body-wrapper {
      &::-webkit-scrollbar {
        height: 0px;
      }
      &::-webkit-scrollbar-thumb {
        height: 0px;
      }
    }
    .vxe-table--border-line {
      border: none;
    }
    .vxe-table--header-wrapper {
      .vxe-table--header-border-line {
        border: none;
      }
      .vxe-table--header {
        // position: relative;
        thead tr th {
          position: relative;
          overflow: visible;
          background-color: #F0F3F7;
          padding: 8px 0;
          height: 40px;
          border-bottom: none;
          .vxe-cell--title {
            position: static;
            color: #7f8596;
            padding-left: 24px;
            font-weight: 600;
            font-size: 12px;
            font-weight: 600;
            vertical-align: middle;
          }
        }
        .col--checkbox + .vxe-header--column .vxe-cell--title {
          padding-left: 0px;
        }
        .col--last.no-dropcolumn {
          .vxe-cell--title {
            padding-right: 24px;
          }
        }
        .vxe-header--column {
          background-image: none !important;
          &.is--sortable {
            cursor: pointer;
            .vxe-cell--title {
              position: relative;
              &::after {
                position: absolute;
                content: "";
                top: 0;
                bottom: 0;
                right: -19px;
                width: 19px;
                background-color: transparent;
                z-index: 1;
              }
            }
          }
        }
      }
    }
    .vxe-table--body tbody .action-cell-container {
      padding: 0;
      .vxe-cell {
        height: 100%;
        .el-dropdown {
          cursor: pointer;
        }
      }
    }
    .vxe-table--body tbody tr td {
      // padding: 8px 0;
      border-bottom: none;
      border-top: none;
      background-image: none;
      height: 40px;
      box-shadow: inset 0 -1px 0 0 #ebeef4;
      &:last-child {
        .vxe-cell {
          // padding-right: 18px;
        }
      }
      .commonEllipsisTooltip  {
        width: auto;
        display: inline-block;
        vertical-align: middle;
        max-width: 78%;
      }
    }
    .vxe-table--body tbody tr .col--checkbox + .vxe-body--column .vxe-cell {
      padding-left: 0px;
    }
    .click-cell {
      cursor: pointer;
    }
    .no-click-cell {
      cursor: auto;
    }
    .vxe-table--body tbody tr td > .vxe-cell {
      min-height: 26px;
      line-height: 26px;
      padding-left: 24px;
      span {
        font-weight: 600;
        font-size: 12px;
        font-weight: 600;
        color: #000000;
        .linkCommon {
          display: inline-block;
          width: 16px;
          height: 16px;
          background-size: 100% 100%;
          cursor: pointer;
          background: url("../images/check-nor.svg") no-repeat;
        }
        .tag {
          line-height: 1;
          display: flex;
          align-items: center;
          &::before {
            $size: 6px;
            display: inline-block;
            content: "";
            width: $size;
            height: $size;
            margin-right: 6px;
            border-radius: 50%;
            margin-top: 1px;
          }
          &--success {
            &::before {
              background-color: #00c473;
            }
          }
          &--error {
            &::before {
              background-color: #ec0000;
            }
          }
          &--pending {
            &::before {
              background-color: #d89800;
            }
          }
          &--inactive {
            &::before {
              background-color: #cf1322;
            }
          }
          &--active {
            &::before {
              background-color: #29a360;
            }
          }
        }
      }
    }
    .vxe-table--body tbody tr .tableTdFontBold > .vxe-cell span {
      font-weight: bold;
    }
    .vxe-table--body tbody tr.row--stripe td {
      background: #FAFBFD;
    }
    .vxe-table--body tbody tr.row--checked td {
      background: #F0F2FA;
    }
    .vxe-table--body tbody tr.row--current {
      background: transparent;
    }
    .vxe-table--body tbody tr.row--current td {
      background: transparent;
    }
    .vxe-table--body tbody tr.row--hover td {
      box-shadow: inset 0 -1px 0 0 #ebecef !important;
      background-color: #E3E8F9 !important;
    }
    .vxe-table--body tr:hover > td {
      box-shadow: inset 0 -1px 0 0 #ebecef !important;
      background-color: #E3E8F9 !important;
    }
    //table loading 自定义
    .el-loading-spinner {
      background-image: url("../images/loading.svg");
      background-repeat: no-repeat;
      background-size: 32px 32px;
      height: 100px;
      width: 100%;
      background-position: center;
      top: 40%;
      animation: Rotation 1s linear infinite;
      @keyframes Rotation {
        from {
          -webkit-transform: rotate(0deg);
        }
        to {
          -webkit-transform: rotate(360deg);
        }
      }
    }
    .el-loading-spinner .circular {
      /*隐藏 之前 element-ui 默认的 loading 动画*/
      display: none;
    }
    // 不允许拖拽列样式
    // .no-dropcolumn {
    //   cursor: no-drop;
    // }
    .vxe-table--empty-placeholder {
      padding: 70px 0;
      align-items: start;
      .vxe-table--empty-content {
        width: 300px;
        .empty-container {
          p {
            &:last-child {
              span {
                font-weight: 500;
                font-size: 12px;
                font-weight: 500;
                color: #7f8596;
              }
            }
          }
        }
      }
    }
    .vxe-cell--sort {
      margin-left: 3px;
      width: 16px !important;
      height: 16px !important;
      i {
        position: initial !important;
        height: 16px !important;
        width: 16px !important;
        line-height: normal;
        vertical-align: top;
      }
      .vxe-icon--caret-top {
        display: none !important;
      }
      .vxe-icon--caret-bottom {
        background-size: 100% 100%;
        background-repeat: no-repeat;
        &::before {
          display: none !important;
        }
      }
      // 默认
      i.vxe-icon--caret-top:not(.sort--active) + i.vxe-icon--caret-bottom:not(.sort--active) {
        background-image: url('../images/icon-filter.svg');
      }
      // 升序
      i.vxe-icon--caret-top.sort--active + i.vxe-icon--caret-bottom:not(.sort--active) {
        background-image: url('../images/up.svg');
      }
      // 降序
      i.vxe-icon--caret-top:not(.sort--active) + i.vxe-icon--caret-bottom.sort--active {
        background-image: url('../images/icon-filter-bottom.svg');
      }
    }
    .vxe-cell--checkbox {
      font-size: 16px !important;
      .vxe-checkbox--icon {
        font-size: 16px !important;
        &::before {
          border: 1px solid #b2b6c0;
          &:hover {
            border-color: #4066d4;
          }
        }
      }
      span {
        margin-top: 1px;
      }
    }
    .vxe-cell--checkbox.is--checked,
    .vxe-cell--checkbox.is--indeterminate {
      .vxe-checkbox--icon {
        &::before {
          border-color: #4066d4;
          background-color: #4066d4;
        }
      }
    }
    .normal-action-container {
      height: 48px;
      display: inline-block;
      line-height: 48px;
      padding-right: 24px;
      .delete-icon {
        &:hover {
          color: #cf1322 !important;
        }
      }
      > span {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-left: 24px;
        &:hover {
          color: #095ee9 !important;
        }
        &:first-child{
          margin-left: 10px;
        }
      }
      .is-disabled {
        cursor: no-drop !important;
        color: #dadce1 !important;
        &:hover {
          color: #dadce1 !important;
        }
      }
    }
    .stops-cell-container {
      .vxe-cell {
        display: flex;
        align-items: center;
      }
    }
  }
  .doc-item-container {
    cursor: pointer;
    img {
      vertical-align: text-bottom;
      margin-right: 4px;
    }
  }
  .team-container {
    height: 26px;
    display: flex;
    align-items: center;
    > div {
      height: 16px;
      display: inline-block;
      max-width: 40%;
      padding-right: 6px;
      border-right: 1px solid #E7EBF3;
    }
    .first {
      display: flex;
      align-items: center; 
    }
    .second {
      padding-left: 6px;
      display: flex;
      align-items: center; 
    }
    .commonEllipsisTooltip  {
      max-width: 100% !important;
    }
    .cardIcon {
      position: relative;
      top: 2px;
    }
  }
  .stops-item-container {
    display: flex;
    width: 20px;
    height: 20px;
    // margin: 0 0.5px;
    border-radius: 100%;
    border: solid 1.5px #000000;
    // text-align: center;
    // cursor: pointer;
    // line-height: 16px;
    font-weight: bold !important;
    font-weight: bold !important;
    justify-content: center;
    align-items: center;
    // line-height: 20px;
  }
  .card-icon-container {
    .cardIcon {
      color: #b2b6c0;
      &:hover {
        color: #7f8596;
      }
    }
  }
  .single-column-click {
    cursor: pointer;
  }
  .transparentB {
    width: 100%;
    height: 100%;
    background: transparent;
    display: inline-block;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .transparent-disabled {
    pointer-events: none;
    cursor: not-allowed;
  }
  .cursor-disabled{
    cursor: not-allowed !important;
  }
  .el-dropdown-link {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url("../images/more.svg") no-repeat center;
    flex: 1;
    position: absolute;
    left: 9px;
    &:hover {
      background: url("../images/more-4.svg") no-repeat center;
    }
  }
  .el-dropdown-disabled-link {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url("../images/more-disabled.svg") no-repeat center;
    pointer-events: none;
    cursor: not-allowed;
    flex: 1;
    position: absolute;
    left: 9px;
  }
  .el-dropdown-active-link {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url("../images/more-4.svg") no-repeat center;
    flex: 1;
    position: absolute;
    left: 9px;
  }
  .cursor-p {
    cursor: pointer;
  }
  .click-cell {
    cursor: pointer;
  }
  .no-click-cell {
    cursor: auto;
  }
  .is-mutiSelect {
    ::v-deep .vxe-table--render-wrapper .vxe-table--body tbody tr td.is-checkbox ~ td:nth-last-of-type(1) {
      border-right: 2px solid #4D7BFF;
    }
  }
}
.action-dropdown-menu-container {
  min-width: 140px;
  padding: 8px;
  border-radius: 6px;
  box-shadow: 0 1px 5px 0 rgba(0, 5, 57, 0.2);
  background-color: rgb(255, 255, 255);
  // margin-right: 15px;
  margin-top: 2px;
  margin-top: -8px !important;
  margin-left: -160px !important;
  .el-dropdown-menu__item {
    font-weight: 500;
    color: #000000;
    line-height: normal;
    min-width: 124px;
    height: 36px;
    padding: 7px 8px 7px 8px;
    border-radius: 4px;
    background-color: #ffffff;
    span {
      font-weight: 500;
      font-size: 12px;
      font-weight: 500;
      color: #000000;
    }
    &:hover {
      background-color: #f4f5f9;
      color: #000000;
    }
  }
  .el-dropdown-menu__item.delete-action-container span {
    color: #000000;
  }
  .el-dropdown-menu__item.delete-action-container {
    &:hover {
      color: #cf1322;
      span {
        color: #cf1322;
      }
    }
  }
  .el-dropdown-menu__item.is-disabled span {
    color: rgb(218, 220, 225);
  }
  ::v-deep {
    .popper__arrow {
      display: none;
    }
  }
  .el-dropdown-menu__item.delete-action-container {
    color: #000000;
  }
  ::v-deep {
    .popper__arrow {
      display: none;
    }
  }
  .single-column-click {
    cursor: pointer;
  }
}
/deep/ .vxe-table--render-default .vxe-table--fixed-right-wrapper.scrolling--middle{
  box-shadow: -4px 0px 4px 0px rgba(0, 0, 0, 0.12);
}
/deep/ .vxe-table--render-default .vxe-table--fixed-left-wrapper.scrolling--middle{
  box-shadow: 4px 0px 4px 0px rgba(0, 0, 0, 0.12);
}
</style>
<style lang="scss">
  .driverPopover{
    &.el-popper .popper__arrow{
      display: block;
      left: 100px !important;
    }
    &el-popper{
      margin-top: 12px !important;
    }
  }
</style>